import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/lib/brand";
import { Reveal, SectionLabel } from "@/components/Motion";

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative border-b border-white/8 py-24 lg:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <SectionLabel index="§ 07">FAQ</SectionLabel>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-display text-[clamp(1.9rem,4vw,3.1rem)] font-extrabold uppercase leading-[0.98] tracking-[-0.015em] text-white">
                Questions,
                <br />
                <span className="text-white/35">answered.</span>
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q} className="border-t border-white/8 last:border-b">
                  <button
                    data-testid={`faq-item-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span
                      className={`font-display text-lg font-semibold uppercase tracking-tight transition-colors duration-300 sm:text-xl ${
                        isOpen ? "text-white" : "text-white/65 group-hover:text-white"
                      }`}
                    >
                      {f.q}
                    </span>
                    <Plus
                      className={`h-4 w-4 shrink-0 text-white/40 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
                        isOpen ? "rotate-45 text-[hsl(var(--orv-blue))]" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="max-w-2xl pb-7 text-sm leading-[1.85] text-white/45">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
